import * as React from "react"
import { AppTableSeeker } from "@components"

import {useUserApp} from "@hooks";
import {usePriceEvolutionTablePricing} from "../../@hooks";
import PriceEvolutionTableLoadingBlock from "./LoadingBlock";
import {productSkuColumn, retailerColumn, dateColumn, priceColumn, percentageColumn, sellerColumn, buyboxColumn, stockColumn} from "./columns";
import { TABS_TABLE } from "../../@contants";
import {PriceEvolutionTabsTableID} from "../../@signals";


export default function PriceEvolutionTablePricingBlock() {
	const { userUseRRSP } = useUserApp()
	const { isLoading, data, selectedLabel, handleExcel, isStandardUser } = usePriceEvolutionTablePricing()
	
	if (isLoading)
		return <PriceEvolutionTableLoadingBlock />
		
	if (!data?.length)
		return <></>

	if (PriceEvolutionTabsTableID.value === TABS_TABLE.MIN_MAX)
		return <></>

	return <AppTableSeeker
		title={`Pricing Daily Details - ${selectedLabel}`}
		data={data}
		columns={[
			dateColumn(),
			...retailerColumn(),
			...productSkuColumn(),
			priceColumn('listPrice', 'List Price'),
			priceColumn('actualPrice', 'Actual Price'),
			percentageColumn('promotion', 'Promotion'),
			...isStandardUser ? [buyboxColumn()] : [],
			...isStandardUser ? [sellerColumn()] : [],
			...stockColumn(),
			...userUseRRSP ? [priceColumn('rrsp', 'RRSP')] : [],
			...userUseRRSP ? [percentageColumn('diffVSrrsp', 'Diff Vs RRSP')] : []
		]}
		options={{
			onDownload: handleExcel
		}}
	/>
}